import { forEach, camelCase, reduce } from 'lodash'
import { exists } from './functions.js'

export function camelizeKeys(obj) {
  const keys = Object.keys(obj)
  forEach(keys, key => {
    const oldKey = key
    const newKey = camelCase(key)
    // Note: Don't overwrite and then delete if key stays the same (e.g. if key 'a' will become 'a', then don't delete 'a' after rename)
    if (newKey !== oldKey) {
      obj[newKey] = obj[oldKey]
      delete obj[oldKey]
    }
  })
  return obj
}

/*
  Renames an object's keys
  E.g. calling renameKeys({foo: 'bar}, ['foo', 'fu]) will return {fu: 'bar}

*/
export function renameKeys(obj = {}, keys = []) {
  keys.forEach(keyPair => {
    obj = renameKey(obj, keyPair[0], keyPair[1])
  })
  return obj
}

export function renameKey(obj, oldName, newName) {
  if (obj.hasOwnProperty(oldName)) {
    obj[newName] = obj[oldName]
    delete obj[oldName]
  }
  return obj
}

export function arrayToKeyedObject(array = [], key = 'id') {
  return reduce(
    array,
    (obj, item) => {
      if (!item.hasOwnProperty(key)) {
        console.warn(`Expected array item to have a ${key} property`)
      }
      obj[item[key]] = item
      return obj
    },
    {}
  )
}

// State management helpers

// merges a map of id keyed entities into a state map, can also accept entities as a list, but will convert to an id-keyed map before merging
export function mergeEntities(destination = {}, entities = {}, defaultAttributes = {}) {
  if (!exists(entities)) {
    return destination
  }
  // first convert array to id-keyed object
  if (Array.isArray(entities)) {
    entities = arrayToKeyedObject(entities, 'id')
  }
  forEach(entities, entity => {
    mergeEntity(destination, entity, defaultAttributes)
  })
  return destination
}

// merges a single entity map into a destination object. Requires an entity id
export function mergeEntity(destination = {}, entity = {}, defaultAttributes = {}) {
  if (!exists(entity)) {
    return destination
  }
  if (!entity.hasOwnProperty('id')) {
    console.warn('Skipping entity, expected it to have an id property')
  } else {
    const idString = entity.id.toString()
    const existing = destination[idString] || {}
    destination[idString] = Object.assign({}, defaultAttributes, existing, entity)
  }
  return destination
}
